module.exports = __webpack_public_path__ + "static/media/imagem-api.7bd1de29.svg";